import rates from './reducers';

export {default as ratesActions} from './actions';
export {default as ratesTypes}   from './types';

export default rates;